export const SUBSCRIPTION_TIER = ['FREE', 'BASIC', 'SMART', 'PRO', 'PREMIUM'] as const;
export type SubscriptionTier = (typeof SUBSCRIPTION_TIER)[number];

/** Aligns with backend `SUBSCRIPTION_BILLING_PERIOD` when present. */
export type SubscriptionBillingPeriod = 'MONTH' | 'YEAR' | 'ONCE';

/** `SUBSCRIPTION_CATEGORY` on `subscription_plans` (aligns with backend `SUBSCRIPTION_CATEGORY`). */
export const SUBSCRIPTION_CATEGORY = ['HOST', 'AGENCY', 'VENUE', 'CATERING', 'TECH', 'SPONSOR', 'OTHER'] as const;
export type SubscriptionCategory = (typeof SUBSCRIPTION_CATEGORY)[number];

export type SubscriptionPlan = {
  /** Present when returned from API (admin list, org subscription populate). */
  id?: string;
  tier: SubscriptionTier;
  /** Bundle price per billing period (catalog). */
  price: number;
  entityType: string;
  features: Record<string, string | number | boolean>;
  billingPeriod?: SubscriptionBillingPeriod;
  includedQuotas?: { quotaKey: string; quantity: number }[];
  /** Optional hard cap per quota key (total units); same row shape as includedQuotas. */
  maxQuotas?: { quotaKey: string; quantity: number }[];
  /** Optional `step` = UI +/- click size for that quota (defaults to 1 when omitted). */
  overagePrices?: { quotaKey: string; pricePerUnit: number; step?: number }[];
  featureKeys?: string[];
  /** Stable product line (multi-subscription; optional — backend may default, e.g. `host_default`). */
  subscriptionProductKey?: string;
  subscriptionCategory?: SubscriptionCategory;
  /** When true, purchase requires a parent org subscription (add-on product line). */
  requiresParent?: boolean;
  /** Eligible parent product key when `requiresParent`. */
  parentProductKey?: string;
  minParentTier?: SubscriptionTier;
  deleted?: boolean;
  /** Prior catalog row this live plan replaced (admin history). */
  supersedesPlanId?: string;
};
